export default __webpack_public_path__ + "static/media/banner1.fa4dd005.png";